import { render } from "./VUploader.vue?vue&type=template&id=7e5f750b"
import script from "./VUploader.vue?vue&type=script&lang=js"
export * from "./VUploader.vue?vue&type=script&lang=js"

import "./VUploader.vue?vue&type=style&index=0&id=7e5f750b&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__